import { GenericResponse, TableRequestV3, TableResponse } from 'services/types'
import { employeeApi } from './employee'
import { AddWorkRequest, AddWorkResponse, EmployeeBaseSearchRequest } from './types'
import { DropdownOptionTemplate } from 'types/common'

const workApi = employeeApi.injectEndpoints({
  endpoints: (build) => ({
    addWork: build.mutation<AddWorkResponse, AddWorkRequest>({
      query: ({ clientId, ...data }) => ({
        url: `clients/${clientId}/work/`,
        method: 'POST',
        data,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Works'],
    }),
    getWorkList: build.query<TableResponse<{}>, TableRequestV3 & { employeeId?: string }>({
      query: ({ clientId, employeeId, ...data }) => ({
        url: `clients/${clientId}/work/list/`,
        params: {
          employee_id: employeeId,
        },
        method: 'POST',
        data,
      }),
      providesTags: ['Works'],
    }),
    searchWork: build.query<
      GenericResponse & { work_list: DropdownOptionTemplate<string> },
      EmployeeBaseSearchRequest
    >({
      query: ({ clientId, searchParam, employeeId, exact }) => ({
        url: `clients/${clientId}/work/search/`,
        method: 'GET',
        params: {
          search_param: searchParam,
          employee_id: employeeId,
          exact,
        },
      }),
    }),
    updateWork: build.mutation<AddWorkResponse, { clientId: string; workId: string; note: string }>(
      {
        query: ({ clientId, workId, ...data }) => ({
          url: `clients/${clientId}/work/${workId}/`,
          method: 'PATCH',
          data,
          headers: {
            'Content-Type': 'application/json',
          },
        }),
        invalidatesTags: ['Works'],
      },
    ),
  }),
})

export const {
  useAddWorkMutation,
  useGetWorkListQuery,
  useLazySearchWorkQuery,
  useUpdateWorkMutation,
} = workApi
